import { cn } from '@/lib/utils';

/**
 * Loading placeholder. Marked aria-hidden and paired with a visually hidden
 * "Loading" message by the callers, so screen readers hear one announcement
 * rather than a wall of empty boxes.
 */
export function Skeleton({ className }: { className?: string }) {
  return (
    <div
      aria-hidden="true"
      className={cn('animate-pulse rounded-md bg-border-subtle', className)}
    />
  );
}

export function TableSkeleton({ rows = 5, columns = 4 }: { rows?: number; columns?: number }) {
  return (
    <div role="status" aria-live="polite" className="space-y-2 p-4">
      <span className="sr-only-focusable">Loading…</span>
      {Array.from({ length: rows }, (_, rowIndex) => (
        <div key={rowIndex} className="flex gap-4">
          {Array.from({ length: columns }, (_, columnIndex) => (
            <Skeleton
              key={columnIndex}
              className={cn('h-5 flex-1', columnIndex === 0 && 'max-w-[14rem]')}
            />
          ))}
        </div>
      ))}
    </div>
  );
}
